import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {isEmpty} from 'lodash'

import Dropzone from 'react-dropzone'
import { TableRow, TableCell, Table, TableBody, TableHead, Button, Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { toast } from 'react-toastify';

class ImportFiles extends Component {
    state = {
        file: [],
        content: "",
        error: ""
    }
    componentDidMount = () => {}
    onDrop = (event) => {
        console.log("[INFO], ", event)
        this.setState({
            // substring to is to limit to 3 characters
            file: event
        });
    }
    parseContent = () => {
        console.log("[PARSE] content, ", this.state.file[0])
        if (this.state.file[0] !== "" && typeof this.state.file[0] !== "undefined") {
            const reader = new FileReader()
            reader.onload = (e) => {
                const text = (e.target.result)
                console.log(text)
                this.setState({content: text})
            };
            let info = reader.readAsText(this.state.file[0])
            console.log("[PARSE] result, ", info)
        }
    }
    uploadContent = async() => {
        console.log("[PARSE] upload FILES, ", this.state.file[0])
        try{
            const dataFile = new FormData()
            dataFile.append('file', this.state.file[0])

            const response = await fetch('/download/upload/account', {
                method: 'POST',
                headers: {
                    //'Content-Type': 'multipart/form-data', 'X-Requested-With': 'XMLHttpRequest',
                },
                body: dataFile,
                credentials: 'same-origin'
            });
            console.log("[INFO], resquest has been sent");
            const resp = await response.json();
            console.log(resp);
            if (resp.msg != "OK") {
                console.log("[SUCESS], handleSubmitDocument response ", resp)
                this.setState({error: resp.error});
                toast.error("Upload failed due to ",resp.error)
                return;
            }
            this.setState({file: [], error: ""});
            toast.success("Upload is ok")
        }catch(err){
            toast.error("Upload failed, ",err)
        }
    }
    render() {
        console.log('====================================');
        console.log("[STATE]", this.state);
        console.log('====================================');

        const files = this.state.file .map(file => (
                <li key={file.name}>
                    {file.name} - {file.size} bytes
                </li>
            ));

        let content = [];
        let header = [];
        let arrayOfLines = this.state.content.split(/\r?\n/);
        arrayOfLines.forEach( (item, ind) => {
            let infos = item.split(",");
            // console.log({infos});
            if (ind === 0) {                
                header.push(
                    <TableRow key={ind}>
                        {infos.map(info => <TableCell>{info}</TableCell> )}
                    </TableRow>
                )
            } else {
                content.push(
                    <TableRow key={ind}>
                        {infos.map(info => <TableCell>{info}</TableCell> )}
                    </TableRow>
                )
            }
        })
        console.log(header);
        return (
            <div className="row">
                Upload files
                <Dropzone onDrop={this.onDrop}>
                    {({getRootProps, getInputProps}) => (
                        <section className="container">
                            <div
                                {...getRootProps({className: 'dropzone'})}
                                style={{
                                "borderStyle": "dashed",
                                "borderRadius": "10px",
                                "borderColor": "#aaa",
                                "textAlign": "center",
                                "fontSize": "20px",
                                height: "100px",
                            }}>
                                <input {...getInputProps()} accept=".csv"/>
                                <p>Deposer vos fichiers</p>
                            </div>
                            <aside>
                                <h4>Files</h4>
                                <ul>{files}</ul>
                            </aside>
                        </section>
                    )}
                </Dropzone>
                <div style={{ display: 'flex'}}>
                    <Box p={1}>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            onClick={this.parseContent}
                        >
                            Parse Document
                        </Button>
                    </Box>
                    <Box p={1}>
                        <Button
                            variant="contained"
                            color="secondary"
                            type="submit"
                            onClick={this.uploadContent}
                        >
                            Upload Document
                        </Button>
                    </Box>

                </div>

                {this.state.error &&
                    <Alert severity="error">
                        {this.state.error}
                    </Alert>
                }
                <div className="table-responsive">
                    <Table>
                        <TableHead>
                            {header}
                        </TableHead>
                        <TableBody>
                            {content}
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}

// function mapStateToProps(state) {
//     return {PROSPECTS: state.prospects.RESUME, CLIENTS: state.clients, PAYMENTS: state.payments, INSTALLERS: state.installers, loading: state.extract.fetching}
// }

// function mapDispatchToProps(dispatch) {}
// export default connect(mapStateToProps, mapDispatchToProps)(ImportFiles);
export default ImportFiles;